export default __webpack_public_path__ + "static/LMshover-601460c5280f676d91e6462f1d086e6e.png";